import { render, staticRenderFns } from "./BannerCompras.vue?vue&type=template&id=37d64178&scoped=true"
import script from "./BannerCompras.vue?vue&type=script&lang=js"
export * from "./BannerCompras.vue?vue&type=script&lang=js"
import style0 from "./BannerCompras.vue?vue&type=style&index=0&id=37d64178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d64178",
  null
  
)

export default component.exports